import type { TruckPartsListQuery } from '@chukua/common';
import { DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { PartTypeView } from '../../part-types/part-types.api';

const DATE_FORMAT = 'YYYY-MM-DD';

interface PartsToolbarProps {
  list: Pick<ListQueryControls<TruckPartsListQuery>, 'query' | 'setQuery'>;
  /** Null until loaded; the select then shows loading rather than "no part types". */
  partTypes: PartTypeView[] | null;
}

/** The register's filters that are not columns: which part types and between which fit dates. Both live in the URL query. */
export function PartsToolbar({ list, partTypes }: PartsToolbarProps) {
  const { query, setQuery } = list;
  const from = query.fittedFrom ? dayjs(query.fittedFrom) : null;
  const to = query.fittedTo ? dayjs(query.fittedTo) : null;

  return (
    <>
      <Select
        mode="multiple"
        allowClear
        loading={partTypes === null}
        className="w-full md:w-64"
        placeholder="Select or search part types"
        aria-label="Part types"
        optionFilterProp="label"
        options={(partTypes ?? []).map((type) => ({ value: type.id, label: type.name }))}
        value={query.partTypeId ?? []}
        onChange={(partTypeId: string[]) => setQuery({ partTypeId })}
      />
      <DatePicker.RangePicker
        allowEmpty={[true, true]}
        aria-label="Fitted between"
        value={[from, to]}
        onChange={(range) => setQuery({ fittedFrom: range?.[0]?.format(DATE_FORMAT), fittedTo: range?.[1]?.format(DATE_FORMAT) })}
      />
    </>
  );
}
